<template>
  <div class="user">
    <!--
    <div class="photo">
     <img :src="avatar" alt="avatar" />
    </div>
    -->

    <div class="user-info" align="Left">
      <a :aria-expanded="!isClosed" data-toggle="collapse" @click.stop="toggleMenu" @click.capture="clicked">
        <span style="text-align: center; margin-bottom: 5px;">{{ title }}<b class="caret"/></span>
        <span style="font-size: .75rem; color: #aaa;">{{ discipline }}</span>
        <span style="font-size: .75rem; color: #aaa;"
          >Qualification:&nbsp; <span style="color: #0277bd;"><b>MD</b></span>
        </span>
        <span style="font-size: .75rem; color: #aaa;"
          >Practice:&nbsp; <span style="color: #0277bd;"><b>Sole Practitioner</b></span>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed" align="Left">
          <ul class="nav">
            <slot>
              <!-- <li>
                <a href="#vue">
                  <span class="sidebar-mini">&nbsp;</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li> -->
              <li>
                <a href="#" @click="goToSettings" class="nav-link" style="display: flex;align-items: center;">
                  <md-icon>settings</md-icon>
                  My Settings
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions"

export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    },
    discipline: {
      type: String,
      default: sessionStorage.getItem("specialization")
    },
    globeid: {
      type: String,
      default: sessionStorage.getItem("kioskid")
    },
    avatar: {
      type: String,
      default: "http://via.placeholder.com/400/3b3b3b/3b3b3b/?text=." // "../../img/GlobeChek_EYE.png"
    }
  },
  data() {
    return {
      isClosed: true
    }
  },
  methods: {
    clicked: function(e) {
      e.preventDefault()
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed
    },
    goToSettings() {
      this.$router.push('/portal/doctor/settings');
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
